var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8081 12.8081C12.5522 13.064 12.1419 13.064 11.8901 12.8081L6.5 7.41798L1.1099 12.8081C0.854007 13.064 0.443759 13.064 0.191923 12.8081C-0.0639744 12.5522 -0.0639744 12.1419 0.191923 11.8901L5.58202 6.5L0.191923 1.1099C-0.0639744 0.854007 -0.0639744 0.443759 0.191923 0.191923C0.447821 -0.0639744 0.858069 -0.0639744 1.1099 0.191923L6.5 5.58202L11.8901 0.191923C12.146 -0.0639744 12.5562 -0.0639744 12.8081 0.191923C13.064 0.447821 13.064 0.858069 12.8081 1.1099L7.41798 6.5L12.8081 11.8901C13.064 12.1419 13.064 12.5562 12.8081 12.8081Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseButton);
export default __webpack_public_path__ + "static/media/modal_close_button.4ab11c2978a77e8849b3ec27f7e5602e.svg";
export { ForwardRef as ReactComponent };